/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Subscription_DetailsInputs */

const en_settings_billing_subscription_details = /** @type {(inputs: Settings_Billing_Subscription_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Details`)
};

/**
* | output |
* | --- |
* | "Subscription Details" |
*
* @param {Settings_Billing_Subscription_DetailsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_subscription_details = /** @type {((inputs?: Settings_Billing_Subscription_DetailsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Subscription_DetailsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_subscription_details(inputs)
});
export { settings_billing_subscription_details as "settings.billing.subscription_details" }